import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './suite/app.module';

enableProdMode();

platformBrowserDynamic().bootstrapModule(AppModule);
